import { HttpClient } from '@/shared/lib/http-client';

export const fetchOrder = async (orderId, typeId = 0) => {
  const response = await HttpClient.get(`/orders/${orderId}/${typeId}`);

  return response.data;
};